<div class='full-form'>
	<mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate" *ngIf='datasetACS.loading.value'></mat-progress-bar>

	<div class='mt-24' *ngIf='datasetACS.ready.value'>
		<dataset-list
			#tripList
			datasetCode='actual_trips'
			[parentDatasetRS]='datasetRS'
			[parentDatasetACS]='datasetACS'
			[showSearchBar]='true'
			[elevate]='false'
			[emitAdd]='true'
			[addButtonText]='"Genera"'
			[filters]='{ trip_package_id: datasetRS.recordId, start_day: todayFilter }'
			(add)='generate()'
		></dataset-list>
		
	</div>
</div>